// extracted by mini-css-extract-plugin
module.exports = {"component":"image-slide_component_3d_ch","bio-visible":"image-slide_bio-visible_Nn8wc"};